import {
  getCheapestHotelsPriceFromSelection,
  getGridPriceData,
  getPreferDirects,
  getPriceColourClass,
  getSelectedInboundDate,
  getSelectedOutboundDate,
  getSelectedViewMode,
  isReturn,
} from '../../selectors';
import getSelectedDaysPrice from '../../selectors/selectedDaysPrice';
import * as actionsConstants from '../constants/actionsConstants';
import * as analyticsConstants from '../constants/analyticsConstants';
import * as dataTypeConstants from '../constants/dataTypeConstants';
import * as mapping from '../data-parsing/analyticsMappingParser';

import type { State } from '../../selectors/types';
import type { GridPriceData } from '../data-parsing/gridEntryHelper';
import type { AnyAction } from 'redux';

const eventCategory = analyticsConstants.MONTHVIEW;
let eventLabel = '';
let eventAction = '';

const selectDay = (action: AnyAction, state: State) => {
  const mode = mapping.viewModeHelper(getSelectedViewMode(state));
  eventAction = mapping.directionSelectHelper(action.payload.direction);
  const returnTrip: boolean = isReturn(state);
  let price: GridPriceData;
  let pricedType: string = analyticsConstants.PRICED;
  if (eventAction === analyticsConstants.RETURNDATESELECT) {
    const inboundDate = getSelectedInboundDate(state);
    if (!returnTrip || !inboundDate) {
      return;
    }
    price = getGridPriceData(state, inboundDate, action.payload.direction);
  } else {
    price = getGridPriceData(
      state,
      getSelectedOutboundDate(state),
      action.payload.direction,
    );
  }

  if (price.price === null) {
    pricedType = analyticsConstants.UNPRICED;
  } // Chart is always priced in GA?

  if (
    mode === analyticsConstants.CHART ||
    pricedType === analyticsConstants.UNPRICED
  ) {
    eventLabel = `${mode}_${pricedType}`;
  } else {
    const colour = getPriceColourClass(state, price.price);
    eventLabel = `${mode}_${pricedType}_${colour}`;
  }
};

const googleAnalyticsTrackingBeforeActionExecution = () => {};

const googleAnalyticsTrackingAfterActionExecution = (
  action: AnyAction,
  state: State,
  logGaEvent: (category: string, label: string, evtAction: string) => void,
) => {
  if (
    action.meta.googleAnalyticsLogEvent ===
    actionsConstants.SET_FLIGHT_VIEW_MODE
  ) {
    eventAction = analyticsConstants.TABCLICK;
    eventLabel = mapping.viewModeHelper(action.payload.mode);
  }
  if (action.meta.googleAnalyticsLogEvent === actionsConstants.SELECT_DAY) {
    if (action.payload.source === dataTypeConstants.AUTOMATED_SOURCE) return;
    selectDay(action, state);
  }
  if (
    action.meta.googleAnalyticsLogEvent ===
    actionsConstants.SET_DIRECTNESS_FILTER_ANALYSIS
  ) {
    eventAction = 'Direct-flights-checkbox';
    eventLabel = `${mapping.viewModeHelper(
      getSelectedViewMode(state),
    )}_${mapping.isCheckedHelper(getPreferDirects(state))}`;
  }

  if (action.meta.googleAnalyticsLogEvent === actionsConstants.SELECT_MONTH) {
    if (action.payload.source === dataTypeConstants.AUTOMATED_SOURCE) return;
    eventAction = `${mapping.directionHelper(
      action.payload.direction,
    )}Month_${mapping.sourceHelper(action.payload.source)}`;
    eventLabel = `${mapping.viewModeHelper(
      getSelectedViewMode(state),
    )}_${analyticsConstants.MONTHNAMES[action.payload.month - 1]}_${
      action.payload.year
    }`;
  }
  if (
    action.meta.googleAnalyticsLogEvent ===
    actionsConstants.CONFIRM_SELECTED_RESULT
  ) {
    eventAction = 'SelectResult';
    let priced = 'Priced';
    if (getSelectedDaysPrice(state) === null) {
      priced = 'Unpriced';
    }
    eventLabel = `${analyticsConstants.SELECTED_VIEW}:${mapping.viewModeHelper(
      getSelectedViewMode(state),
    )}_${priced}, ${analyticsConstants.SELECTED_TAB}:${analyticsConstants.FLIGHTS_TAB}`;
  }
  if (
    action.meta.googleAnalyticsLogEvent ===
    actionsConstants.CONFIRM_SELECTED_HOTEL
  ) {
    eventAction = 'SelectHotel';
    let priced = 'Priced';
    if (getCheapestHotelsPriceFromSelection(state, null, null) === null) {
      priced = 'Unpriced';
    }
    eventLabel = `${analyticsConstants.SELECTED_VIEW}:${mapping.viewModeHelper(
      getSelectedViewMode(state),
    )}_${priced}, ${analyticsConstants.SELECTED_TAB}:${analyticsConstants.FLIGHTS_TAB}`;
  }

  logGaEvent(eventCategory, eventLabel, eventAction);
};

const googleAnalyticsLogger = (
  action: AnyAction,
  state: State,
  afterActionExecution: boolean,
  logGaEvent: (category: string, label: string, evtAction: string) => void,
) => {
  if (afterActionExecution) {
    googleAnalyticsTrackingAfterActionExecution(action, state, logGaEvent);
  } else {
    googleAnalyticsTrackingBeforeActionExecution(); // noop
  }
  const gaLog = {
    category: eventCategory,
    label: eventLabel,
    action: eventAction,
  };
  return gaLog;
};

export default googleAnalyticsLogger;
